/**
 * Central table of Pro-gate messaging. Keyed by route path so we can look up
 * the feature title + description in one place. Used by AppRoutes.jsx to
 * wrap Pro-only pages with a consistent upgrade prompt.
 */

/**
 * Pro access is sold externally: users buy THE INCOME BLUEPRINT digital
 * bundle on our Linktree, then accounts are manually upgraded within 24h.
 */
export const PRO_ACCESS_URL = 'https://linktr.ee/Safehouseservices';
export const PRO_BUNDLE_NAME = 'THE INCOME BLUEPRINT';
export const PRO_FEATURES = {
  '/journal': {
    feature: 'Trade Journal',
    description:
      "Track every trade, P&L, win rate, R-multiple, and tag your setups so you can spot what's working.",
  },
  '/screener': {
    feature: 'Stock Screener',
    description:
      'Filter the entire market by 30+ fundamental, technical, and analyst-rating criteria.',
  },
  '/research': {
    feature: 'Deep Research',
    description:
      'AI-summarised fundamentals, peer comparisons, and risk factors for any ticker.',
  },
  '/chart-analyzer': {
    feature: 'AI Chart Analyzer',
    description:
      'Search a symbol or upload a chart screenshot — AI reads the trend, candlestick patterns, and technicals, then suggests an educational trade idea with entry, take-profit and stop-loss.',
  },
  '/alerts': {
    feature: 'Price & Volume Alerts',
    description:
      'Set unlimited alerts on price, volume, RSI, and earnings — delivered via Telegram or email.',
  },
  '/courses': {
    feature: 'AI Course Creator',
    description:
      'Generate complete study courses on any investing topic — modules, lessons, videos and quizzes built by AI.',
  },
  '/backtest': {
    feature: 'Strategy Backtesting',
    description:
      'Run any of 100+ strategies against historical data and see returns, drawdown, and win rate.',
  },
  '/marketplace': {
    feature: 'Strategy Marketplace',
    description:
      'Browse and copy proven strategies published by other Neon Alpha members.',
  },
  '/community': {
    feature: 'Private Community',
    description:
      'Members-only Discord, Telegram, and Circle. Real-time discussions, weekly calls, and curated resource drops.',
  },
};
